import type { ListLayoutDefaults } from './defaultSettings';

export const mapListLayoutSettings = (settings: ListLayoutDefaults) => {
  const {
    listItemSpacing,
    listShowLoadMoreButton,
    showLoadMoreButton,
    limitTotalNumberOfItems,
    totalNumberOfItems,
    listItemsPerPage,
    listItemsPerPageOnMobile
  } = settings;

  return {
    itemSpacing: listItemSpacing,
    // Приоритет: новая настройка ?? старая настройка
    showLoadMoreButton: showLoadMoreButton ?? listShowLoadMoreButton,
    limitTotalNumberOfItems,
    totalNumberOfItems,
    itemsPerPage: listItemsPerPage,
    itemsPerPageOnMobile: listItemsPerPageOnMobile
  };
};
